import {
  AccordionDownIcon,
  ChartIcon,
  ClipboardIcon,
  CloudIcon,
  DoorIcon,
  FacilityIcon,
  GatewayIcon,
  LevelerIcon,
  MobileIcon,
  SensorIcon,
  WrenchIcon,
} from 'features/CaseStudy/assets/icons';

const ICON_NAME_TO_ICON = {
  clipboard: <ClipboardIcon />,
  facility: <FacilityIcon />,
  sensor: <SensorIcon />,
  door: <DoorIcon />,
  leveler: <LevelerIcon />,
  mobile: <MobileIcon />,
  cloud: <CloudIcon />,
  gateway: <GatewayIcon />,
  chart: <ChartIcon />,
  wrench: <WrenchIcon />,
  accordionDown: <AccordionDownIcon />,
} as const;

export type IconName = keyof typeof ICON_NAME_TO_ICON;

type IconProps = {
  iconName: IconName;
} & React.HTMLAttributes<HTMLDivElement>;

export const Icon = ({ iconName, ...props }: IconProps) => {
  return <div {...props}>{ICON_NAME_TO_ICON[iconName]}</div>;
};
